import axios from 'axios'
import { resolveApiBase } from '@/utils/apiBase'

const baseURL = resolveApiBase()

const service = axios.create({
  baseURL,
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => response.data,
  error => {
    if (!error.response) {
      const raw = error.message || ''
      const hint =
        raw === 'Network Error'
          ? '无法连接后端服务，请确认本机已启动 glt-crm-server（默认 :11000）；开发模式下接口经前端端口代理到该端口，勿忘 npm run serve'
          : raw || '请求失败'
      return Promise.reject(new Error(hint))
    }
    const d = error.response.data
    const msg =
      (d && (d.message || d.error || d.msg)) ||
      (typeof d === 'string' ? d : null) ||
      error.message ||
      '请求失败'
    return Promise.reject(new Error(msg))
  }
)

export default service

